import React from "react";
import { Button, Popup } from "semantic-ui-react";
import { openModal } from "../../../app/common/modals/modalSlice";
import { useDispatch } from "react-redux";
import _ from "lodash";

export default function AgentShareButton({ doc, party, transaction, allParties, isMobile }) {
  const dispatch = useDispatch();

  function handleShare() {
    dispatch(
      openModal({
        modalType: "AgentShare",
        modalProps: { doc, party, transaction, allParties },
      })
    );
  }

  // Determine the agent's own client roles
  const ownClientRoles =
    transaction.agentRepresents === "Buyer"
      ? ["Seller", "Seller 2", "Seller 3"]
      : transaction.agentRepresents === "Seller"
      ? ["Buyer", "Buyer 2", "Buyer 3"]
      : [];

  const ownClientParties = allParties
    ? allParties.filter((p) => ownClientRoles.includes(p.role))
    : [];

  // Clients who are already in doc.sharingWith
  const sharedClients = ownClientParties.filter(
    (p) => p.email && doc.sharingWith?.includes(p.email)
  );

  function formatSharedAt(role) {
    const details = doc.sharedWithDetails?.[_.camelCase(role)];
    if (!details?.sharedAt) return null;
    const date =
      details.sharedAt instanceof Date
        ? details.sharedAt
        : details.sharedAt?.toDate?.();
    if (!date) return null;
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  const popupContent = (
    <div>
      <p className="bold text blue mini bottom margin">Share</p>
      {sharedClients.length > 0 ? (
        <>
          {sharedClients.map((client, i) => {
            const date = formatSharedAt(client.role);
            const name =
              [client.firstName, client.lastName].filter(Boolean).join(" ") ||
              client.role;
            return (
              <p key={i} style={{ margin: "2px 0" }}>
                Shared with {name} ({client.email})
                {date ? ` on ${date}` : ""}
              </p>
            );
          })}
          <p style={{ marginTop: "8px", color: "#666" }}>
            Click to update email address for sharing.
          </p>
        </>
      ) : (
        <p>
          Click to share this document with your clients.
          <br />
          You can select which clients to share with and add or update their
          email addresses.
          <br />
          The document will appear in your clients' Client Portal so they can
          view it.
        </p>
      )}
    </div>
  );

  return (
    <Popup
      content={popupContent}
      trigger={
        <Button
          color="blue"
          floated={isMobile ? null : "right"}
          className={isMobile ? "fluid medium bottom margin" : null}
          size="small"
          onClick={() => handleShare()}
        >
          Share{sharedClients.length > 0 ? "d" : ""}
        </Button>
      }
      position="top center"
      wide="very"
    />
  );
}
